import { useForm } from "react-hook-form";
import { useState, useEffect, useRef, useMemo } from "react";
import Modal from "./Modal";
import ModalRemove from "./ModalRemove";
import { useDispatch, useSelector } from "react-redux";
import {
  ObtenerTodos,
  ActualizarEstadoPeriodo,
  ImportarPeriodos,
  ActualizarPeriodosFechas,
  InsertarPeriodosFechas,
  ObtenerTiposSesiones,
  ObtenerTiposPeriodos,
  ActualizarPeriodos,
} from "../../redux/periodosSlice";
import WindowDimension from "../../Hooks/WindowDimension";
import Required from "../../Components/Required";
import { OrderTable } from "../../Components/OrderTable";
import useSubmit from "../../Hooks/useSubmit";
import { getAdminPeriodPage } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { Skeleton } from "antd";
import { StrapiError } from '../../Inicio/Pages/StrapiError';
import { _translateValue } from "../translation-gestor/translateValue";

import { useValidation } from "../../Hooks/useValidation";

const SCREEN_NAME = "PantallaPeriodos";
function Periodos(props) {
  const { validation } = useValidation();
  const { width } = WindowDimension();
  const { locale } = useLocale();
  const [adminPeriodPage, setAdminPeriodPage] = useState(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const [translatedTiposPeriodos, setTranslatedTiposPeriodos] = useState({});
  const [translatedEstados, setTranslatedEstados] = useState({});
  const [isTranslating, setIsTranslating] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [tituloModal, setTituloModal] = useState("Agregar");
  const [removeState, changeRemoveState] = useState(false);
  const [itemSelected, setItemSelected] = useState({});

  const dispatch = useDispatch();
  let caracter = useRef();
  let filtroAnio = useRef();
  const { periodos, tiposPeriodos } = useSelector((state) => state.periodos);

  const { submitAction } = useSubmit();

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();
  const {
    register: registerP,
    formState: { errors: errorsP },
    handleSubmit: handleSubmitP,
    reset: resetP,
  } = useForm();

  const columns = useMemo(() => {
    const table = adminPeriodPage?.period_table ?? [];
    return [
      { label: table[0]?.label || "Código", accessor: "periodoId", sortable: true },
      { label: table[1]?.label || "Nombre", accessor: "periodoNombre", sortable: true },
      { 
        label: table[2]?.label || "Tipo de periodo", 
        accessor: "tipoNombre", 
        sortable: true,
        render: (item) => (
          <td>{translatedTiposPeriodos[item.tipoNombre] || item.tipoNombre}</td>
        ),
      },
      { label: table[3]?.label || "Año", accessor: "anio", sortable: true },
      {
        label: table[4]?.label || "Estado",
        accessor: "estatus",
        sortable: true,
        render: (item) => (
          <td style={{ color: item.color }}>
            {translatedEstados[item.estatus] || item.estatus}
          </td>
        ),
      },
      { label: table[5]?.label || "Acción", accessor: "action", sortable: false },
    ];
  }, [adminPeriodPage, translatedTiposPeriodos, translatedEstados]);

  const showModalEdit = (item) => {
    setItemSelected(item);
    reset(item);
    item.periodosFechaAperturaId === 0
      ? setTituloModal(adminPeriodPage?.subtitleO || "Agregar fechas")
      : setTituloModal("Editar fechas");

    setShowModal(true);
  };
  const showEdit = (item) => {
    setItemSelected(item);
    resetP(item);
    setShowEditModal(true);
  };

  const closeModalEdit = () => {
    reset({ periodoId: 0, periodoNombre: "" });
    setShowModal(false);
  };
  const closeModal = () => {
    resetP({ periodoId: 0, periodoTipoId: 0 });
    setShowEditModal(false);
  };

  const showRemoveModalEdit = (item) => {
    setItemSelected(item);
    changeRemoveState(true);
  };

  const closeRemoveModalEdit = () => {
    setItemSelected({});
    changeRemoveState(false);
  };

  const cargarPeriodos = () => {
    dispatch(ObtenerTodos());
    dispatch(ObtenerTiposSesiones());
    dispatch(ObtenerTiposPeriodos());
  };

  const cargarPeriodosPorCaracter = () => {
    let object = { anio: null, periodoNombre: caracter.current.value };
    dispatch(ObtenerTodos(object));
  };

  const cargarPeriodosPorAnio = () => {
    let object = { anio: filtroAnio.current.value, periodoNombre: null };
    dispatch(ObtenerTodos(object));
  };

  const actualizarEstado = async (estado) => {
    let object = { id: itemSelected.periodoId, estado: estado };
    submitAction(ActualizarEstadoPeriodo, object, () => {
      closeRemoveModalEdit();
      cargarPeriodos();
    });
  };

  const importar = async () => {
    submitAction(ImportarPeriodos, undefined, cargarPeriodos);
  };

  const onSubmit = async (data) => {
    submitAction(
      data.periodosFechaAperturaId > 0
        ? ActualizarPeriodosFechas
        : InsertarPeriodosFechas,
      data,
      () => {
        closeModalEdit();
        cargarPeriodos();
      }
    );
  };

  const onSubmitP = async (data) => {
    let model = {
      id: data.periodoId,
      periodoTipo: data.periodoTipoId,
    };
    submitAction(ActualizarPeriodos, model, () => {
      closeModal();
      cargarPeriodos();
    });
  };

  useEffect(() => {
    cargarPeriodos();
  }, [dispatch]);

  useEffect(() => {
    let cancel = false;
    setIsLoadingContent(true);
    getAdminPeriodPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          setAdminPeriodPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => { 
        if (!cancel) {
          setAdminPeriodPage(null);
          setIsLoadingContent(false);
        }
      });
    return () => { cancel = true };
  }, [locale])

  // Efecto para traducir los campos "Tipo de periodo" y "Estado" cuando lleguen los datos o cambie el locale
  useEffect(() => {
    const translateData = async () => {
      // Verificar si hay datos para traducir
      const hasPeriodos = periodos && Array.isArray(periodos) && periodos.length > 0;

      // Si no hay datos, no hacer nada
      if (!hasPeriodos) {
        setIsTranslating(false);
        return;
      }

      // Iniciar traducción
      setIsTranslating(true);

      const tiposPeriodosTranslations = {};
      const estadosTranslations = {};
      const translationPromises = [];

      // Recopilar todos los valores únicos que necesitan traducción
      periodos.forEach((item) => {
        // Traducir tipo de periodo
        if (item.tipoNombre && !tiposPeriodosTranslations[item.tipoNombre]) {
          tiposPeriodosTranslations[item.tipoNombre] = null; // Marcador para evitar duplicados
          translationPromises.push(
            _translateValue(SCREEN_NAME, item.tipoNombre, locale).then((translated) => {
              tiposPeriodosTranslations[item.tipoNombre] = translated;
            })
          );
        }
        
        // Traducir estado
        if (item.estatus && !estadosTranslations[item.estatus]) {
          estadosTranslations[item.estatus] = null; // Marcador para evitar duplicados
          translationPromises.push(
            _translateValue(SCREEN_NAME, item.estatus, locale).then((translated) => {
              estadosTranslations[item.estatus] = translated;
            })
          );
        }
      });
      
      await Promise.all(translationPromises);

      // Actualizar estados y finalizar traducción
      setTranslatedTiposPeriodos(tiposPeriodosTranslations);
      setTranslatedEstados(estadosTranslations);
      setIsTranslating(false);
    };

    translateData();
  }, [periodos, locale]);

  if (isLoadingContent || isTranslating) {
    return (
      <div className="main-admin">
        <div className="main-admin-bar">
          <div className="header-admin-bar-items">
            <Skeleton.Input style={{ width: 200, height: 30 }} active />
          </div>
          <div className="header-admin-bar-items ml-auto">
            <Skeleton.Input style={{ width: 150, height: 40 }} active />
            <Skeleton.Input style={{ width: 200, height: 40 }} active />
            <Skeleton.Button style={{ width: 40, height: 40 }} active />
          </div>
        </div>
        <div className="table-container">
          <Skeleton.Input style={{ width: '100%', height: 400, minWidth: '800px' }} active />
        </div>
      </div>
    );
  }

  return (
    <div className="main-admin">
      <div className="main-admin-bar">
        <div className="header-admin-bar-items">
          <h2>{adminPeriodPage?.title || "Periodos"}</h2>
        </div>
        <div className="header-admin-bar-items ml-auto">
          <label hidden>Filtrar por año</label>
          <select ref={filtroAnio} onChange={cargarPeriodosPorAnio}>
            <option value={0}>{adminPeriodPage?.select_option || "Todos los años"}</option>
            {new Array(40).fill(0).map((b, i) => (
              <option key={i} value={new Date().getFullYear() + 1 - i}>
                {new Date().getFullYear() + 1 - i}
              </option>
            ))}
          </select>
          <label hidden>Búsqueda</label>
          <input
            onChange={cargarPeriodosPorCaracter}
            type="search"
            className="form-control"
            ref={caracter}
            placeholder={adminPeriodPage?.search_input || "Búsqueda"}
          />

          <button className="search-button" onClick={importar}>
            <i className="material-icons"></i>
          </button>
        </div>
      </div>

      <div className="table-container">
        {periodos?.length > 0 ? (
          <>
            <OrderTable
              {...{ columns }}
              data={periodos}
              clase="table-adm"
              renderActionItems={(item) => {
                return (
                  <td key={Math.random()}>
                    <button
                      className="modBtn text-primary "
                      onClick={() => {
                        showEdit(item);
                      }}
                    >
                      <i className="material-icons"></i>
                    </button>
                    <button
                      className="modBtn text-primary "
                      onClick={() => {
                        showModalEdit(item);
                      }}
                    >
                      <i className="material-icons"></i>
                    </button>
                    <button
                      className="delete"
                      onClick={() => {
                        showRemoveModalEdit(item);
                      }}
                    >
                      {item.estadoId === 4 ? (
                        <i className="material-icons statusRed"></i>
                      ) : (
                        <i className="material-icons statusGreen"></i>
                      )}
                    </button>
                  </td>
                );
              }}
            />
          </>
        ) : (
          <div className="no-results-container">
            <img src={props.img} alt="Imagen sin resultados" />
            <h1>{props.noResultMessage}</h1>
          </div>
        )}
      </div>

      <Modal
        estado={showModal}
        cambiarEstado={closeModalEdit}
        titulo={tituloModal}
        clase={""}
        buttonGroup={
          <>
            <button
              type="submit"
              className="button-text"
              onClick={handleSubmit(onSubmit)}
            >
              {adminPeriodPage?.save_button || "Guardar"}
            </button>
          </>
        }
      >
        <form>
          {itemSelected.periodosFechaAperturaId === 0 ? (
            <label>
              {adminPeriodPage?.subtitleT_subt || "Nuevas fechas de inscripción del período"}
              <pre />
              {itemSelected.periodoNombre} {itemSelected.anio}
            </label>
          ) : (
            <label>
              {adminPeriodPage?.subtitleT_subt || "Edición de fechas de inscripción establecidas para el período"}
              <pre />
              {itemSelected.periodoNombre} {itemSelected.anio}
            </label>
          )}
          <div className="flex-form gap-20">
            <div>
              <div className="form-group flex-form">
                <input
                  type="checkbox"
                  {...register("abiertoAestudiante")}
                  name="abiertoAestudiante"
                />
                <label>{adminPeriodPage?.period_status || "Estado del periodo - estudiantes"}</label>
              </div>

              <div className="form-group">
                <label>{adminPeriodPage?.startdate || "Fecha de inicio para estudiantes"}</label>
                <Required />
                <input
                  type="date"
                  className="form-control"
                  name="fechaEstudianteApertura"
                  {...register("fechaEstudianteAperturaFormato", {
                    required: validation?.required_field || "Campo requerido",
                  })}
                />
                {errors.fechaEstudianteAperturaFormato && (
                  <p className="error">
                    {errors.fechaEstudianteAperturaFormato.message}
                  </p>
                )}
              </div>

              <div className="form-group">
                <label>{adminPeriodPage?.enddate || "Fecha de fin para estudiantes"}</label>
                <Required />
                <input
                  type="date"
                  className="form-control"
                  {...register("fechaEstudianteCierreFormato", {
                    required: validation?.required_field || "Campo requerido",
                  })}
                />
                {errors.fechaFin && (
                  <p className="error">
                    {errors.fechaEstudianteCierreFormato.message}
                  </p>
                )}
              </div>
            </div>

            <div>
              <div className="form-group flex-form">
                <input
                  type="checkbox"
                  {...register("abiertoAadministrador")}
                  name="abiertoAadministrador"
                />
                <label>{adminPeriodPage?.period_status_admin || "Estado del periodo - administradores"}</label>
              </div>

              <div className="form-group">
                <label>{adminPeriodPage?.startdate_admin || "Fecha de inicio para administradores"}</label>
                <Required />
                <input
                  type="date"
                  className="form-control"
                  {...register("fechaAdministradorAperturaFormato", {
                    required: validation?.required_field || "Campo requerido",
                  })}
                />
                {errors.fechaInicio && (
                  <p className="error">
                    {errors.fechaAdministradorApertura.message}
                  </p>
                )}
              </div>

              <div className="form-group">
                <label>{adminPeriodPage?.enddate_admin || "Fecha de fin para administradores"}</label>
                <Required />
                <input
                  type="date"
                  className="form-control"
                  {...register("fechaAdministradorCierreFormato", {
                    required: validation?.required_field || "Campo requerido",
                  })}
                />
                {errors.fechaFin && (
                  <p className="error">
                    {errors.fechaAdministradorCierre.message}
                  </p>
                )}
              </div>
            </div>
          </div>
        </form>
      </Modal>

      <ModalRemove
        estado={removeState}
        closeModalHandled={closeRemoveModalEdit}
        title={adminPeriodPage?.subtitleTR || "Eliminar período"}
        message={
          itemSelected.estadoId === 4
            ? adminPeriodPage?.question || "¿Seguro que desea desactivar el siguiente registro?"
            : adminPeriodPage?.questionP || "¿Seguro que desea activar el siguiente período?"
        }
        item={itemSelected.periodoNombre}
        btnGroup={
          <>
            <button
              className="button-text text-red"
              onClick={() =>
                actualizarEstado(itemSelected.estadoId === 4 ? 5 : 4)
              }
            >
              {adminPeriodPage?.confirm_button || "Confirmar"}
            </button>
            <button
              className="button-text text-grey"
              onClick={() => {
                closeRemoveModalEdit(false);
              }}
            >
              {adminPeriodPage?.cancel_button || "Cancelar"}
            </button>
          </>
        }
      />

      <Modal
        estado={showEditModal}
        cambiarEstado={closeModal}
        titulo={adminPeriodPage?.subtitleT || "Editar"}
        clase={`${width < 576 ? "full-width" : "small"}`}
        buttonGroup={
          <>
            <button
              type="submit"
              className="button-text"
              onClick={handleSubmitP(onSubmitP)}
            >
              {adminPeriodPage?.save_button || "Guardar"}
            </button>
          </>
        }
      >
        <form>
          <div className="form-group">
            <label>{adminPeriodPage?.periodtype || "Tipo de periodo"}</label>
            <Required />
            <select
              className="form-control"
              {...registerP("periodoTipoId", { required: validation?.required_field || "Campo requerido" })}
            >
              <option value={undefined}>Seleccione</option>
              {tiposPeriodos?.map((a, i) => {
                return (
                  <option key={i} value={a.periodoTipoId}>
                    {a.periodoTipoNombre}
                  </option>
                );
              })}
            </select>
            {errorsP.periodoTipoId && (
              <p className="error">{errorsP.periodoTipoId.message}</p>
            )}
          </div>
        </form>
      </Modal>
    </div>
  );
}

export default Periodos;
